export const closeModal = (e, modal, cb = null) => {
  const dialogDimensions = modal.getBoundingClientRect();

  if (e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
  ) {
    modal.close();
    cb?.();
    const body = document.body;
    const scrollY = body.style.top;
    body.style.position = '';
    body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
};

export const modalHandler = (modal) => {
  const closeButton = modal.querySelector('#modal-close-button');
  showDialog();
  if (closeButton) closeButton.addEventListener('click', () => modal.close());
};

const showDialog = () => {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'relative';
  body.style.top = `-${scrollY}`;
};
